module.exports = __webpack_public_path__ + "img/user-center-banner-bg.81234596.png";